import { URL_API } from "@/config";

const endpoint = `${URL_API.replace(/\/$/, "")}/telemetry/client-error`;

function report(message, stacktrace = "", kind = "client_error") {
  void fetch(endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    keepalive: true,
    body: JSON.stringify({
      message: String(message || "Browser error").slice(0, 16000),
      stacktrace: String(stacktrace || "").slice(0, 16000),
      kind,
      route: window.location.pathname,
      context: { client: "avhris-backoffice", user_agent: navigator.userAgent.slice(0, 500) },
    }),
  }).catch(() => undefined);
}

export function installClientTelemetry() {
  window.addEventListener("error", (event) => report(event.message, event.error?.stack));
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
    report(reason.message, reason.stack, "unhandled_rejection");
  });
}
